export default __webpack_public_path__ + "static/media/planet@3x.2ba04e8a.png";